import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/components/ui/table";
import { formatCurrency } from "../../utils/billing-utils";
import type { PayoutUser } from "../types/commissions.types";

interface PayoutsTableProps {
  users: PayoutUser[];
  quarterLabel: string;
  onRowClick: (user: PayoutUser) => void;
  /** Optional map of user id -> summed estimated commission for the period (from reports) */
  userIdToEstimatedCommission?: Record<string, number>;
}

const PayoutsTable: React.FC<PayoutsTableProps> = ({
  users,
  quarterLabel,
  onRowClick,
  userIdToEstimatedCommission,
}) => {
  return (
    <div className="rounded-md border border-gray-200 overflow-hidden bg-white">
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-50 border-b border-gray-201">
            <TableHead className="font-medium text-gray-700 py-3 px-3">
              Name
            </TableHead>
            <TableHead className="font-medium text-gray-700 py-3 px-3">
              Email
            </TableHead>
            <TableHead className="font-medium text-gray-700 py-3 px-3">
              Rate
            </TableHead>
            <TableHead className="font-medium text-gray-700 py-3 px-3">
              Est. Commission (
              {quarterLabel}
              )
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <TableRow
              key={user.id}
              className="cursor-pointer hover:bg-gray-50 border-b border-gray-201"
              onClick={() => onRowClick(user)}
            >
              <TableCell className="font-medium py-4 px-3">
                {user.name}
              </TableCell>
              <TableCell className="text-gray-600 py-4 px-3">
                {user.email}
              </TableCell>
              <TableCell className="py-4 px-3">
                {user.activePercent}
                %
              </TableCell>
              <TableCell className="py-4 px-3">
                {userIdToEstimatedCommission?.[user.id] != null
                  ? formatCurrency(userIdToEstimatedCommission[user.id])
                  : user.estimatedPayoutForQuarter != null
                    ? formatCurrency(user.estimatedPayoutForQuarter)
                    : "—"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default PayoutsTable;
